import { AdminSubHeader } from "@admin/Header/admin-subHeader";
import { MenuDivider } from "@common/index";
import { Outlet } from "react-router-dom";

export const AdminInventory = () => {
    return (
        <>
            <AdminSubHeader />
            <MenuDivider>Inventory</MenuDivider>
            <Outlet />
        </>
    );
};
